module.exports = __webpack_public_path__ + "media/coffee-preferences/equitable_trade_sometimes-2f5d8b98.png";